import { REACT_APP__IS_FOREIGN, storeEp } from "@smp/utils";

import { ELocale } from "@/context/language/language.types";
import { getValidLocale } from "@/utils";

const navigatorLanguage = navigator.language.substring(0, 2);

const storeLanguage = storeEp.get("language_code");

const defaultLocale = getValidLocale([storeLanguage, navigatorLanguage]);

export const messagesLoader = async (
  locale?: ELocale,
): Promise<{
  locale: ELocale;
  messages: Record<string, string>;
}> => {
  locale = locale || defaultLocale;

  let { messages } = await import(`@/config/locales/${locale}/messages.js`);

  if (!REACT_APP__IS_FOREIGN) {
    const { messages: messagesDangerous } = await import(
      `@/config/locales/${locale}/messages_dangerous.js`
    );

    messages = {
      ...messages,
      ...messagesDangerous,
    };
  }

  return {
    messages,
    locale,
  };
};
